export const DEFAULT_STAGE_PROPS = { height: 600, width: 800 };
export const DEFAULT_CROP_TOOL_PROPS = { height: 200, width: 200 };
export const DEFAULT_CROP_SCALE = { x: 1, y: 1 };
export const DEFAULT_IMAGE_CROP = { x: 0, y: 0, height: 0, width: 0 };
export const DEFAULT_IMAGE_PROPS = { height: 600, width: 800 };
export const DEFAULT_BRIGHTNESS = 0;
export const MAX_STAGE_HEIGHT = 600;
export const UPDATE_PREVIEWING = 'ImageEditor/UPDATE_PREVIEWING';
export const UPDATE_CROPPING = 'ImageEditor/UPDATE_CROPPING';
export const UPDATE_WAS_CROPPING = 'ImageEditor/UPDATE_WAS_CROPPING';
export const UPDATE_SAVING = 'ImageEditor/UPDATE_SAVING';
export const UPDATE_BRIGHTNESS = 'ImageEditor/UPDATE_BRIGHTNESS';
export const UPDATE_IMAGE_CROP = 'ImageEditor/UPDATE_IMAGE_CROP';
export const UPDATE_STAGE_PROPS = 'ImageEditor/UPDATE_STAGE_PROPS';
export const UPDATE_CROP_TOOL_PROPS = 'ImageEditor/UPDATE_CROP_TOOL_PROPS';
export const UPDATE_IMAGE_PROPS = 'ImageEditor/UPDATE_IMAGE_PROPS';
export const UPDATE_CROP_SCALE = 'ImageEditor/UPDATE_CROP_SCALE';
export const CANCEL_IMAGE_PREVIEW = 'ImageEditor/CANCEL_IMAGE_PREVIEW';
export const SAVE_IMAGE = 'ImageEditor/SAVE_IMAGE';
export const SAVE_IMAGE_SUCCESS = 'ImageEditor/SAVE_IMAGE_SUCCESS';
export const SAVE_IMAGE_FAILURE = 'ImageEditor/SAVE_IMAGE_FAILURE';
export const VIEW_IMAGE_PREVIEW = 'ImageEditor/VIEW_IMAGE_PREVIEW';
export const UPDATE_KEEP_ASPECT_RATIO = 'ImageEditor/UPDATE_KEEP_ASPECT_RATIO';
